import React from "react";
import axios from "axios";
import Rotas from "./rotas/Rotas";
import RotasPassword from "./rotas/RotasPassword";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
//import 'antd/dist/antd.css';

export const AuthContext = React.createContext();

const initialState = {
    name: null,
    email: null,
    expiresIn: 0,
    auth: false,
    token: null,
    id: null,
    message: null,
    url: null,
    features: [],
};

const reducer = (state, action) => {
    console.log("action.type", action.type);
    switch (action.type) {
        case "LOGIN":
            localStorage.setItem("name", action.payload.name);
            localStorage.setItem(
                "expiresIn",
                JSON.stringify(action.payload.expiresIn)
            );
            localStorage.setItem("auth", action.payload.auth);
            localStorage.setItem("token", action.payload.token);
            return {
                ...state,
                name: action.payload.name,
                email: action.payload.email,
                expiresIn: action.payload.expiresIn,
                auth: action.payload.auth,
                token: action.payload.token,
                id: action.payload.id,
                message: action.payload.message,
                startSession: action.payload.startSession,
                url: action.payload.url,
                papel: action.payload.papel,
                features: action.payload.features,
            };
        case "LOGOUT":
            localStorage.clear();
            return {
                ...state,
                name: null,
                //expiresIn: 0,
                auth: null,
                token: null,
                message: null,
                id: null,
                url: null,
                papel: null,
                startSession: null,
                features: [],
            };
        default:
            return state;
    }
};

axios.interceptors.request.use(
    async (config) => {
        let token = localStorage.getItem("token");
        if (localStorage.getItem("token")) {
            config.headers["Authorization"] = token;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

function App() {
    const [state, dispatch] = React.useReducer(reducer, initialState);

    return (
        <AuthContext.Provider
            value={{
                state,
                dispatch,
            }}
        >
            <div className="App">{!state.auth ? <RotasPassword /> : <Rotas />}</div>
        </AuthContext.Provider>
    );
}

export default App;
